import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuthPageStyles } from '../../authentication/styles';
import { ReactComponent as BasicSurveyPageIcon } from '../images/basicSurveyPageIcon.svg';
import useHotjar from '../../hotjar/useHotjar';
import ReactHtmlParser from 'html-react-parser';
import PaperContainer from '../../authSimplified/components/PaperContainer';
import { apiUrls, routeMappings } from '../../constants';
import { StaticPageIconStyles } from '../../common/styles/staticPageIcon';
import axios from '../../common/utils/interceptor';
import taskItemStatusMapper from '../../taskList/utils/taskItemStatusMapper';
import { Task, TaskListConfiguration } from '../../taskList/interfaces';
import { TaskItemStatus } from '../../taskList/constants';
import { useAppSelector } from '../../store/hook';
interface BasicSurveyPageData {
  triggerCode: string;
  loading: boolean;
}

const BasicSurveyPage = (): React.JSX.Element => {
  const currentWorkflowItem = useAppSelector((state) => state.currentWorkflowItem);
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const { classes } = AuthPageStyles({ isICPEnabled: isICPEnabled });
  const { classes: StaticPageIconClasses } = StaticPageIconStyles();

  const [basicSurveyPageData, setBasicSurveyPageData] = useState<BasicSurveyPageData>({
    triggerCode: '',
    loading: true,
  });
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleEndWorkflowRedirection = (): void => {
    const { configuration, nestedItemsState } = currentWorkflowItem;
    const parsedConfig: TaskListConfiguration = configuration && JSON.parse(configuration).configWidgetJSON;
    const { tasks } = parsedConfig;

    const taskitems = tasks && nestedItemsState && taskItemStatusMapper(tasks, nestedItemsState);
    const isWorkflowCompleted =
      taskitems &&
      taskitems.length > 0 &&
      taskitems.every((task: Task) => task.optional || task.status === TaskItemStatus.COMPLETED);

    if (isWorkflowCompleted) {
      navigate(routeMappings[`${currentWorkflowItem.code}_END`]);
    } else {
      navigate(routeMappings[`${currentWorkflowItem.code}_HURDLE_FAIL`]);
    }
  };

  useEffect(() => {
    (async (): Promise<void> => {
      setBasicSurveyPageData((prevState) => ({ ...prevState, loading: true }));
      try {
        const { data } = await axios.get(apiUrls.GET_BASICFLOW_SURVEY_TRIGGER_CODES);
        data && data.triggerCode && setBasicSurveyPageData({ triggerCode: data.triggerCode, loading: false });
      } catch (e) {
        setBasicSurveyPageData((prevState) => ({ ...prevState, loading: false }));
        console.log('error occured on basic survey page', e);
      }
    })();
  }, []);

  useHotjar(!!basicSurveyPageData.triggerCode, basicSurveyPageData.triggerCode);

  return (
    <PaperContainer variant="medium" className={classes.paper}>
      <Grid container justifyContent="center" className={classes.container}>
        <Grid item xs={12}>
          <Box textAlign={'center'}>
            <BasicSurveyPageIcon className={StaticPageIconClasses.staticPageIcon} />
          </Box>
          <Box textAlign={'center'} mb={2.5}>
            <Typography variant="h1" id="surveyPage">
              {t('basicSurveyHeading')}
            </Typography>
          </Box>
          <Box textAlign={'center'} mb={2.5}>
            <Typography variant="body1">{t('basicSurveyPara1')}</Typography>
          </Box>
          <Box textAlign={'center'} mb={3}>
            <Typography variant="body1">{ReactHtmlParser(t('basicSurveyPara2'))}</Typography>
          </Box>
          <Grid container>
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item>
                  <Button variant="outlined" onClick={handleEndWorkflowRedirection} color="secondary">
                    {t('skip')}
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" onClick={handleEndWorkflowRedirection} color="primary">
                    {t('continue')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PaperContainer>
  );
};

export default BasicSurveyPage;
